

import React, { useEffect, useState } from "react";
import Folder from "./components/folder";
import ConfirmModal from "../../components/modals/ConfirmModel";
import { useNavigate, useParams } from "react-router-dom";
import PageTableHeader from "../../components/pageTableHeader/pageTableHeader";
import {
  deleteFolder,
  detailFolder,
  getFolders,
  downloadFolder,
} from "../../../services/workspace/fileManager.service";
import CommonModal from "../../components/modals/commonModel";
import FolderForm from "../../components/forms/fileManager/folderForm";
import toast from "react-hot-toast";
import { downloadFile } from "../../../utils/helper";
import noFolder from "../../assets/lottie/nofolder.json";
import NoDataGet from "../../components/noDataGet/noDataGet";
import CommonForm from "../../components/form/form";
import CommonTable from "../../components/table/table";
import { getDesignationList } from "../../../services/workspace/designation.service";
import { getDepartmentList } from "../../../services/workspace/department.service";
import useCommonFetch from "../../../hooks/useCommonFetch";
import { convertToLabelValue } from "../../../utils/common";
import { getUserList } from "../../../services/workspace/user.service";
import { updateFolder } from "../../../services/workspace/photos.service";

const items = [{ label: "Photos" }];

const Photos = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isFolderModalOpen, setIsFolderModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState("");
  const [folderToEdit, setFolderToEdit] = useState(null);
  const [folderToDelete, setFolderToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [folders, setFolders] = useState([]);

  // staff list state
  const [staffData, setStaffData] = useState([]);
  const [filteredStaff, setFilteredStaff] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  // fetch folder list
  const getFoldersList = async () => {
    try {
      setIsLoading(true);
      let response;
      if (id) {
        response = await detailFolder(id);
        setFolders(response.folder?.data || []);
      } else {
        response = await getFolders();
        setFolders(response.folder?.data || []);
      }
    } catch (error) {
      console.error("Error fetching folders:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const actions = [
    {
      label: "Share Now",
      icon: null,
      onClick: () => shareFolder(),
      color: "text-primary-800",
    },
  ];

  const shareFolder = async () => {
    if (!isShareModalOpen || selectedIds.length === 0) {
      toast.error("Please select at least one staff to share with!");
      return;
    }

    try {
      const response = await updateFolder(isShareModalOpen, {
        sharedUsers: selectedIds.map(item=>item.data),
      });

      if (response.status === 200) {
        toast.success("Folder shared successfully!");
        setIsShareModalOpen(false);
        setSelectedIds([]);
      } else {
        toast.error(response.data?.message || "Failed to share folder");
      }
    } catch (error) {
      toast.error("Error sharing folder");
    }
  };

  const handleEdit = (id) => {
    const folderToEdit = folders.find((folder) => folder.id === id);
    setFolderToEdit(folderToEdit);
    setIsFolderModalOpen(true);
  };

  const handleView = (folder) => {
    navigate(`${folder.uuid}`);
  };

  const handleShare = (folder) => {
    setIsShareModalOpen(folder.uuid);
  };

  const confirmDelete = async (id) => {
    try {
      setFolderToDelete(id);
      setIsDeleteModalOpen(true);
    } catch (error) {
      console.error("Error deleting folder:", error);
      toast.error("Error deleting folder");
    }
  };

  const handleDelete = async () => {
    try {
      const response = await deleteFolder(folderToDelete);
      if (response.status === 200) {
        setFolders(folders.filter((folder) => folder.uuid !== folderToDelete));
        setIsDeleteModalOpen(false);
        setFolderToDelete(null);
        setRefresh(!refresh);
        toast.success("Folder deleted successfully");
      } else {
        toast.error("Error deleting folder");
      }
    } catch (error) {
      console.error("Error deleting folder:", error);
      toast.error("Error deleting folder");
    }
  };

  const closeFolderModal = () => {
    setIsFolderModalOpen(false);
    setIsShareModalOpen(false);
    setFolderToEdit(null);
  };

  const handleDownloadFolder = async (folder) => {
    try {
      const response = await downloadFolder({ folder_id: folder.uuid });
      if (response.status === 200) {
        downloadFile(response.data.url, "download");
        toast.success("Folder downloaded successfully");
      } else {
        toast.error(response.data?.message || "Error downloading folder");
      }
    } catch (error) {
      toast.error("Error downloading folder");
    }
  };

  const fetchDepartment = () => {
    getDepartmentList({})
      .then((response) => {
        setDepartmentList(
          convertToLabelValue(response.department.data || []) || []
        );
      })
      .catch((error) => {
        toast.error("Failed to fetch department data!");
      });
  };

  const fetchDesignation = async (departmentId = null) => {
    const params = { with: "department" };
    return getDesignationList(params)
      .then((response) => {
        const list = Array.isArray(response?.designation?.data)
          ? response.designation.data
          : [];
        const depIdStr = departmentId != null ? String(departmentId) : null;
        const filtered = depIdStr
          ? list.filter((item) => String(item?.department?.id) === depIdStr)
          : list;
        const options = convertToLabelValue(filtered || []) || [];
        setDesignationList(options);
        return options;
      })
      .catch((error) => {
        toast.error("Failed to fetch designation data!");
        return [];
      });
  };

  const {
    data: staffList,
    action,
    handleSearchChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    fetchData,
  
  
  } = useCommonFetch(getUserList, {
    dataPath: "user.data",
    totalPath: "user.meta.total",
    errorMessage: "Failed to fetch user data!",
    debounceDelay: 500,
    autoFetch:false,
    customParams: {
      type:2,
      with: "department,designation",
      
      department_id:selectedDepartment,
      designation_id:selectedDesignation,
    },
    

    dataTransformer: (data) => {
      if (Array.isArray(data)) {
        const transformedData = data.map((item, index) => ({
          ...item,
          uuid: {
            data: item?.uuid,
            className: "",
            sticky: false,
            variant: "text",
          },
          id: {
            data: item?.id,
            className: "",
            sticky: false,
            variant: "checkbox",
          },
          code: {
            data: item?.code,
            className: "",
            sticky: false,
            variant: "checkbox",
          },
          name: {
            data: item?.name,
            className: "",
            sticky: false,
            variant: "text",
          },

          department: {
            data: item?.department?.name || "", // ensure it exists
            className: "",
            sticky: false,
            variant: "text",
          },
          designation: {
            data: item?.designation?.name || "",
            className: "",
            sticky: false,
            variant: "text",
          },
        }));
        return {
          data: transformedData,
        };
      }
      return { data: [], action: {} };
    },
  });

  useEffect(() => {
    setFilteredStaff(staffList.data || []);
  }, [staffList]);

  const handleSubmit = (values, e) => {
    if (e?.preventDefault) e.preventDefault(); // stop form submit reload
    return fetchData({
      department_id: selectedDepartment,
      designation_id: selectedDesignation,
    },true);
  };


  const handleDepartmentChange = (departmentId) => {
    setSelectedDepartment(departmentId);
    setDesignationList([]);
    if (departmentId) {
      fetchDesignation(departmentId);
    }
  };

  const handleDesignationChange = (departmentId) => {
    setSelectedDesignation(departmentId);
   
  };

  useEffect(() => {
    getFoldersList();
    fetchDesignation();
    fetchDepartment();
  }, [id, refresh]);
  // staff filter form fields
  const comprehensiveFields = [
    {
      name: "department_name",
      label: "Department Name",
      type: "select",
      placeholder: "Enter department name",
      required: true,
      options: departmentList,
      onChange: (value) => handleDepartmentChange(value?.value),
      colSpan: 6,
    },
    {
      name: "designation_name",
      label: "Designation Name",
      type: "select",
      placeholder: "Enter designation name",
      required: true,
      options: designationList,
      disabled: !selectedDepartment,
      onChange: (value) => handleDesignationChange(value?.value),
      colSpan: 6,
    },
  ];

  // staff table headers
  const TableHeaderData = [
    {
      label: "Staff ID",
      key: "code",
    },
    {
      label: "Staff Name",
      key: "name",
    },
    {
      label: "Department",
      key: "department",
    },
    {
      label: "Designation",
      key: "designation",
    },
  ];


  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        isFilter={false}
        add
        onClickAdd={() => setIsFolderModalOpen(true)}
      />

      <div className="h-[calc(100vh-200px)] bg-white overflow-y-auto">
        <div className="flex flex-row flex-wrap gap-4 p-4 ">
          {isLoading ? (
            [...Array(7)].map((_, index) => <FolderSkeleton key={index} />)
          ) : folders.length > 0 ? (
            folders.map((folder) => (
              <Folder
                key={folder.id}
                folder={folder}
                onEdit={handleEdit}
                onView={handleView}
                onDelete={confirmDelete}
                onShare={handleShare}
                onDownloadFolder={handleDownloadFolder}
                isMainPage={true}
              />
            ))
          ) : (
            <div className="col-span-4 w-full flex items-center justify-center h-[calc(100vh-240px)]">
              <NoDataGet
                message="No Folder Found"
                lottie={noFolder}
                folderFucnction={() => setIsFolderModalOpen(true)}
              />
            </div>
          )}
        </div>
      </div>

      {isFolderModalOpen && (
        <CommonModal
          modalSize="lg"
          headerTitle="Create Folder"
          onClose={closeFolderModal}
          show={isFolderModalOpen}
        >
          <FolderForm
            isModal={true}
            closeModal={closeFolderModal}
            id={id}
            editFolder={folderToEdit}
            refresh={refresh}
            setRefresh={setRefresh}
          />
        </CommonModal>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmModal
        title="Are You sure?"
        message="Are you sure you want to delete this? This action is permanent and cannot be reversed."
        isOpen={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        onConfirm={handleDelete}
      />

      {isShareModalOpen && (
        <CommonModal
          modalSize="2xl"
          headerTitle="Share Folder"
          onClose={closeFolderModal}
          show={isShareModalOpen}
        >
          <div className="flex flex-col gap-2 overflow-auto">
            <div className="p-4">
              <CommonForm
                fields={comprehensiveFields}
                initialData={{ department_name: null, designation_name: null }}
                onSubmit={handleSubmit}
                submitButtonText="Filter"
                columnsPerRow={1}
                gap="gap-4"
                rowClassName="   "
                fieldClassName="bg-white p-3 rounded shadow-sm"
              />

              <div className="mt-6">
                <CommonTable
                  TableHeaderData={TableHeaderData}
                  tabledata={filteredStaff}
                  loading={false}
                  selectionKey="id"
                  selectedRows={selectedIds}
                  onSelectionChange={setSelectedIds}
                  actions={actions}
                />
              </div>
            </div>
          </div>
        </CommonModal>
      )}
    </div>
  );
};

const FolderSkeleton = () => (
  <div className="pt-6">
    <div className="bg-light rounded-b-md rounded-r-md transition p-4 pt-2 flex flex-col gap-1 w-[170px] relative animate-pulse">
      <div className="bg-light absolute -top-5 rounded-t-md left-0 h-5 w-20"></div>
      <div className="flex justify-between items-start">
        <div className="w-10 h-10 rounded-full bg-gray-200"></div>
        <div className="w-3 h-6 rounded-md bg-gray-200"></div>
      </div>
      <div className="h-4 bg-gray-200 rounded w-3/4 mt-2"></div>
      <div className="h-3 bg-gray-200 rounded w-1/2"></div>
    </div>
  </div>
);

export default Photos;
